<div class="modal-header">
  <h2 mat-dialog-title>Are you sure?</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p>This element @if (moreDeleted > 1) {
    <span>and all related elements ({{deleteElementsCounterString}})</span>
    } will be deleted.
    @if (affectedElementsCounter>0) {
      <span> {{affectedElementsCounter}} cards or slots related to this card will be affected.</span>
    }
  </p>
  <p>Do you wish to continue?</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" class="button" (click)="cancel()">Cancel</button>
  <button type="button" class="button action-alert" (click)="confirmDeleteAssessmentElement()">Delete</button>
</mat-dialog-actions>
